import axios from 'axios';

const API_URL = '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('hubToken');
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }
  return config;
});

// Flag to prevent redirect loops
let isRedirecting = false;

// Public pages that don't require authentication
const publicPages = ['/login', '/register', '/forgot-password', '/reset-password'];

// Add response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Get current path
    const currentPath = window.location.pathname;
    
    // Check if we're on a public page
    const isPublicPage = publicPages.some(page => currentPath === page);
    
    // Check if error is due to unauthorized access (token expired or invalid)
    if (error.response && 
        (error.response.status === 401 || error.response.status === 403) && 
        !isRedirecting && 
        !isPublicPage &&
        currentPath !== '/login') {
      
      isRedirecting = true;
      
      // Clear auth data from localStorage
      localStorage.removeItem('hubToken');
      
      // Store a message to display on the login page
      localStorage.setItem('authError', 'Your session has expired. Please log in again.');
      
      const dest = `${window.location.pathname}${window.location.search}`;
      window.location.href = `/login?redirect=${encodeURIComponent(dest)}`;
      
      // Reset the flag after a short delay
      setTimeout(() => {
        isRedirecting = false;
      }, 1000);
    }
    
    return Promise.reject(error);
  }
);

export default api; 
